const state = {
  csName  : 'accordionWrap' , // 아코디언 최상위 태그 클래스명 
  status : {} , 
  accordionH : 0 , 
} ; // end of state 

const mutations = {
  setState( state : any , obj : any ) {
    Object.assign( state , { ...state , ...obj }) ; 
  } , 
} ; // end of mutations 

const actions = {
  // 선택된 아코디언 
  async setCrntElement ({ state , rootState } , $el : any ) {
    return new Promise( resolve => {
      const { CommNew : { elements }} = rootState ; 
      const rootElem = $el.closest( `.${ state.csName }` ) ; 
      const idx = rootElem.dataset.id ; 
      resolve( elements[ idx ] ) ; 
    }) ; 
  } , 
  // 아코디언내의 HTMLElement 세팅 
  setElemNode ({ state , rootState } , { idx , ...elem }) {
    let { elements } = rootState.CommNew ; 
    let { elemNodes } = elements[ idx ] ; 
    Object.assign( elemNodes , { ...elemNodes , ...elem }) ; 

    /* console.log( 
      '[aclist_new.ts -> setElemNode in]\n' , 
      'idx : ' , idx , '\n' , 
      'elem : ' , elem , '\n' , 
      'elements[ idx ] : ' , elements[ idx ] , '\n' , 
    ) ;  */
  } , 
  hideHandler ({ state , rootState } , { crntElement }) {
    Object.assign( crntElement.status.size , {
      ...crntElement.status.size , 
      open : false , 
      scrH : 0 , 
      gapH : 0 , 
    }) ; 
  } , 
  showhideHandler ({ state , rootState } , { crntElement }) {
    let { elements } = rootState.CommNew ; 
    let { accordionH } = state ; 
    let {
      idx : crntIdx , 
      elemNodes : {
        header , 
        scrlHeader , 
        tagSrchInput , 
      } , 
    } = crntElement ; 

    /* console.log( 'elements : ' , elements ) ; 
    console.log( 'header : ' , header ) ; 
    console.log( 'scrlHeader : ' , scrlHeader ) ; 
    console.log( 'tagSrchInput : ' , tagSrchInput ) ;  */

    let titleH = header.offsetHeight ; 
    let tagSrchH = tagSrchInput.offsetHeight ; 
    let scrlTitleH = scrlHeader.offsetHeight ; 
    let mT = parseFloat( getComputedStyle( header.closest( 'li' ) , null )['marginTop'] ) ; 
    let tagListLen = elements.length ; 
    let btmGap = 10; 
    let remainedH = Math.abs( accordionH - titleH * tagListLen - mT * tagListLen - btmGap ) ; 


    header.closest( 'li' ).querySelector( '.srchWrap > input' ).focus() ; 

    const newElements:Object[] = [] ; 
    elements.map(( element : any , idx : Number ) => {
      let { open , scrH , gapH } = element.status.size ; 
      open = ( crntIdx == idx ) ? true : false ; 
      scrH = ( crntIdx == idx ) ? Math.abs( remainedH ) : 0 ; 
      gapH = ( crntIdx == idx ) ? scrH - (scrH - tagSrchH - scrlTitleH) : 0 ; 
      Object.assign( element.status.size , { ...element.status.size , open , scrH , gapH }) ; 
      
      newElements[ newElements.length ] = element ; 
      /* console.log(
        '[aclist_new.ts -> showhideHandler in - inside]\n' , 
        'scrH : ' , scrH , '\n' , 
        'open : ' , open , '\n' , 
      ) */
    }) ; 

    // console.log( 'test22 : ' , elements[0].status.size.open ) ; 
    // console.log( 'test22 : ' , elements[0].status.size.scrH ) ; 

    header.closest( 'li' ).querySelector( '.srchWrap > input' ).focus() ; 

    state.elements = newElements ; 

    /* console.log( 
      '[aclist_new.ts -> showhideHandler in]\n' , 
      'crntElement : ' , crntElement , '\n' , 
      'elements : ' , elements , '\n' , 
      'titleH : ' , titleH , '\n' , 
      'tagSrchH : ' , tagSrchH , '\n' , 
      'scrlTitleH : ' , scrlTitleH , '\n' , 
      'mT : ' , mT , '\n' , 
      'remainedH : ' , remainedH , '\n' , 
      'accordionH : ' , accordionH , '\n' , 
    ) ;  */
  } , 

  changeTagListView ({ state , rootState } , { idx , viewStatus }) {
    let { elements } = rootState.CommNew ; 
    let crntElement = elements[ idx ] ; 

    // crntElement.status.tagListView = null ; 
    // setTimeout(() => {
    Object.assign( crntElement.status , {
      ...crntElement.status , 
      tagListView : viewStatus , 
    }) ; 
    // }) ; 

    /* 
    console.log(
      '[aclist_new.ts -> changeTagListView in]\n' , 
      'idx : ' , idx , '\n' , 
      'viewStatus : ' , viewStatus , '\n' , 
      'elements : ' , elements , '\n' , 
    ) ; 
    */
  } , 

  changeSrchList ({ state , rootState } , { idx , list }) {
    let { elements } = rootState.CommNew ; 
    let crntElement = elements[ idx ] ; 
    crntElement.srchList = list ; 
    // Object.assign( elements[idx] , crntElement ) ; 
  } , 

  updateCrntTagListStatus ({ rootState } , { crntElement , tagListStatus }) {
    let { elements } = rootState.CommNew ; 
    let { idx } = crntElement ; 

    Object.assign( elements[ idx ].status , {
      ...elements[ idx ].status , 
      tagList : tagListStatus != 'recent' ? 'recent' : 'garbage' ,  
    }) ; 

    /* console.log(
      'aclist_new.ts -> updateCrntTagListStatus in\n' , 
      'crntElement : ' , crntElement , '\n' , 
      'tagListStatus : ' , tagListStatus , '\n' , 
      'elements : ' , elements , '\n' , 
    ) ;  */
  } , 
} ; // end of actions 

const getters = {
  csName ( state : any ) {
    return state.csName ; 
  } , 
} ; // end of getters 

export default {
  namespaced: true,
  state ,
  mutations , 
  actions , 
  getters ,
} ; 